import { useMutation } from '@tanstack/react-query';

import { incentiveCampaign } from 'services';

export const useMutationIncentiveCampaignSSO = () =>
  useMutation(['INCENTIVE_CAMPAIGN_SSO_MUTATION'], incentiveCampaign.sso.get);
